export default class Resources {

    initialize() {

        const paginationLoading = () => {
            $('.resources-pagination .page-link, .resources-pagination-mobile .page-link').on('click', function(e) {
                e.preventDefault();
                Livewire.emit('startLoading');
            });
        }

        paginationLoading();

        Livewire.on('startLoading', event => {
            setTimeout(() => {
                Livewire.emit('stopLoading');
                paginationLoading();
            }, 350);
        });

    }

} // end Resources